<p>
    <slot />
</p>

<style>
    p {
        margin: 0 0 1rem;
        color: var(--color-grey-600);
        font-size: 1rem;
        line-height: 1.65;
    }

    :global(.darkmode) p {
        color: var(--color-grey-200);
    }
</style>
